import { createSelector } from 'reselect';
import { IUserState, TAbilityRules } from './interfaces';

const userSelector = ({ userReducer }: { userReducer: IUserState }) => userReducer;

export const getPermissions: (state: { userReducer: IUserState }) => TAbilityRules = createSelector(
  userSelector,
  ({ userAbilitiesReducer }) => userAbilitiesReducer.permissions,
);

export const getUserstore = createSelector(
  userSelector,
  ({ userstore }) => userstore,
);
